
import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData } from "../../../services/api";
import { hideAddBankModal } from "./bankModalDispatcher";

  

  export const addBankRequest = (data, navigate) => {
    return async (dispatch) => {
      dispatch({"type":"ADD_BANK_REQUEST"});
      try {
        var bankResponse = (data.id)? await updateData(data, `${ApiURLs.BANK}/${data.id}`):await postData(data, ApiURLs.BANK);
        if (bankResponse.status === 1) {
          dispatch({"type":"ADD_BANK_SUCCESS"});
          dispatch(hideAddBankModal());
          dispatch(bankLisitingRequest());
        } else {
          dispatch({"type":"ADD_BANK_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"ADD_BANK_FAILED"});
  
      }
    };
  };




  export const bankLisitingRequest = () => {

    return async (dispatch) => {

      const url = `${ApiURLs.BANK}`;
  
      // wait untill the data not received so getData function take data and url part
      dispatch({"type":"GET_BANK_REQUEST"});
      try {
        var bankData = await fetchData(url);
        console.log(`response when we try to get bank  ${JSON.stringify(bankData)}`)
        if (bankData.status === 1) {
          dispatch({"type":"GET_BANK_REQUEST_SUCCESS", "payload":bankData.data.result});
        
        } else {
          dispatch({"type":"GET_BANK_REQUEST_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"GET_BANK_REQUEST_FAILED"});
        console.log(`error while try to get bank  ${error}`)
      }
    }
  };



    export const deleteBank = (id) => {
      return async (dispatch) => {
    
        // dispatch();
        dispatch({"type":"DELETE_BANK_REQUEST"});
        try {
    
  
          var bankResponse = await deleteData(`${ApiURLs.BANK}/${id}`);
          if (bankResponse.status === 1) {
            dispatch({"type":"ADD_BANK_SUCCESS"});
            dispatch(bankLisitingRequest());
          } else {
            dispatch({"type":"ADD_BANK_FAILED"});
          }
        } catch (error) {
          dispatch({"type":"ADD_BANK_FAILED"});
    
        }
      };
    };
  

  